
<template>
  <div class="container">
    <div style="position: fixed;z-index:1;width:100%;background: #f7f7f7;">
      <form class="searchForm"
            action="/">
        <van-search v-model="content"
                    placeholder="请输入代买人昵称"
                    shape="round"
                    :clearable="false"
                    class="searchHead"
                    @search="onSearchAgent">
          <div slot="right-icon"
               v-if="IsClearable == true">
            <van-icon name="clear"
                      @click="onClear" />
          </div>
        </van-search>
        <div class="searchButton"
             @click="onSearchAgent(content)">搜索</div>
      </form>
    </div>

    <div v-if="list.length > 0"
         :class="AgentIsShow == true ? 'scrollAgent' : 'scroll'">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了~"
                @load="onLoad"
                :immediate-check="false">
        <div v-for="item in list"
             :key="item.id"
             class="name_list">
          <van-swipe-cell>
            <div class="flex_address">
              <div class="flex"
                   style="flex: 1;">
                <span @click="onEdit(item)"
                      style="color: #969799;padding-top: 4px;">
                  <van-icon name="edit"
                            size="20" />
                </span>
                <div style="padding: 0 16px;flex: 1;color: #000;"
                     class="NickNameTitle ellipsisText">
                  {{ item.nickName }}
                </div>
              </div>
              <div @click="onConfirm(item)"
                   style="color: #EE0A24;">
                为TA代买
              </div>
            </div>
            <template #right>
              <van-button square
                          text="删除"
                          type="danger"
                          class="delete-button"
                          @click='onDelete(item)' />
            </template>
          </van-swipe-cell>
        </div>
      </van-list>
    </div>
    <van-dialog v-model="IsShowEdit"
                showCancelButton
                confirmButtonText="确定"
                cancelButtonText="取消"
                confirm-button-color="#ee0a24"
                :before-close="onBeforeClose">
      <div class="editNickName">
        <div class="vanNickName">编辑代买人昵称</div>
        <div :class="errMess == true ? 'mess' : 'errMessHeight'">
          <van-field label-width="15vw"
                     v-model="user.nickName"
                     :value="user.nickName"
                     clearable
                     :maxlength="50"
                     @input="onInputNickName"
                     :border="false">
          </van-field>
        </div>

        <!--  -->
        <div class="redMess"
             v-if="errMess">请输入汉字、英文或数字</div>
      </div>
    </van-dialog>
    <van-dialog v-model="close"
                confirmButtonText="我知道了"
                cancelButtonColor="#9c9c9c"
                @confirm="close = false"
                v-if="AgentIsShow">
      <div class="flexCenter"
           style="padding: 32px 42px;font-size: 14px;flex-wrap: wrap;">
        <div>您正在为「 </div>
        <div class="ellipsisText ellipsisDisabledWidth">{{ agentShow.address.nickName }}</div>
        <div> 」代买{{ activeText }}</div>
      </div>
    </van-dialog>
    <div class="noAgents"
         v-if="list.length == 0 && !listSearch">
      <div class="nullPage">
        <img src="../../../assets/images/update.png"
             alt />
      </div>
      <div class="noAgentText">还没有代买人哦~</div>
    </div>

    <div class="noAgents"
         v-if="listSearch">
      <div class="imageEmptySearch"
           style="margin: auto;">
        <img src="../../../assets/images/search.png"
             alt />
      </div>
      <div class="noAgentText">无搜索结果</div>
    </div>
    <div class="bottomBackground">
      <van-button type="danger"
                  class="bottomBtn"
                  @click="onAdd">新增代买人</van-button>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Search,
  AddressList,
  Toast,
  Cell,
  Panel,
  Icon,
  Tag,
  Button,
  List,
  PullRefresh,
  Overlay,
  Dialog,
  SwipeCell,
  Field,
  Notify
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/buyAgent";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Search.name]: Search,
    [AddressList.name]: AddressList,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
    [SwipeCell.name]: SwipeCell,
    [Field.name]: Field,
    [Notify.name]: Notify,
    loading
  },
  data () {
    return {
      IsClearable: false,
      errMess: false,
      activeText: '',
      close: false,
      user: {},
      IsShowEdit: false,
      content: "",
      isLoading: true, //loading状态
      chosenAddressId: "1",
      list: [],
      listSearch: true,
      disabledlist: [],
      defaultAddress: {},
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow"]),
    AgentIsShow () {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },

  },
  watch: {
    'content': {
      handler (val) {
        let value = val.toString()
        if (value !== '') {
          this.IsClearable = true
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateUserCartQuantity", "buyAgentStatus"]),
    // 搜索
    onSearchAgent (content) {
      console.log(content, "content")
      this.isLoading = true;
      this.page = 1;
      if (content.trim() !== "") {
        // 搜索接口
        this.IsClearable = true
        this.nickNameList().then((nickNameList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.finished = false;
          if (nickNameList.items.length !== 0) {
            this.list = nickNameList.items;
            this.listSearch = false;
            if (nickNameList.totalCount <= this.list.length) {
              this.finished = true;
              this.loading = false;
            }
          } else {
            this.list = [];
            this.listSearch = true;
          }
        });
      } else {
        // 输入框没有东西
        this.isLoading = false;
      }
    },
    // 清除搜索内容时触发
    onClear () {
      this.IsClearable = false
      console.log(this.IsClearable, 210)
      this.listSearch = false;
      this.content = ''
      this.isLoading = true;
      this.page = 1;
      this.nickNameList().then((nickNameList) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.finished = false;
        if (nickNameList.items.length !== 0) {
          this.list = nickNameList.items;
          if (nickNameList.totalCount <= this.list.length) {
            this.finished = true;
            this.loading = false;
          }
        } else {
          this.list = [];
          this.listSearch = false;
        }
      });
    },
    // 编辑
    onEdit (item) {
      if (this.AgentIsShow == true && item.id == this.agentShow.address.mallAgentId) {
        this.close = true
        this.activeText = '不可编辑'
      } else {
        this.user = JSON.parse(JSON.stringify(item))
        this.IsShowEdit = true
      }
      // this.$router.push({
      //     name: "buyAgentedit",
      //     query: { id: item.id, type: "update" }
      // });
    },
    onInputNickName (e) {
      console.log(e, 223)
      var reg = /^[0-9a-zA-Z\u4E00-\u9FA5]+$/;
      if (!reg.test(e)) {
        this.errMess = true
      } else {
        this.errMess = false
      }
    },
    onBeforeClose (action, done) {
      var reg = /^[0-9a-zA-Z\u4E00-\u9FA5]+$/;
      if (action === "confirm") {
        if (!reg.test(this.user.nickName)) {
          this.errMess = true
          done(false);
          Toast("请输入汉字、英文或数字");
        } else {
          this.errMess = false
          this.IsShowEdit = true
          this.isLoading = true;
          service
            .update(this.user)
            .then((res) => {
              if (res.statusCode == 200) {
                Toast("编辑成功");
                this.IsShowEdit = false
                this.init();
                setTimeout(() => {
                  this.isLoading = false;
                }, 1000);
                done(true);

              } else {
                this.IsShowEdit = true
                setTimeout(() => {
                  this.isLoading = false;
                }, 700);
                return done(false);
              }
            })
            .catch((err) => {
              // Toast(err);
              this.IsShowEdit = true
              setTimeout(() => {
                this.isLoading = false;
              }, 700);
              return done(false);
            });
        }
      }
      else {
        this.errMess = false
        done(true); //关闭弹窗, true可以省略
      }
    },
    // 去代买人信息内
    onConfirm (item) {
      this.$router.push({
        name: "buyAgent",
        query: { id: item.id, name: item.nickName }
      });
    },
    init () {
      this.listSearch = false;
      this.page = 1;
      this.nickNameList().then((nickNameList) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.finished = false;
        if (nickNameList.items.length !== 0) {
          this.list = nickNameList.items;
          if (nickNameList.totalCount <= this.list.length) {
            this.finished = true;
            this.loading = false;
          }

        } else {
          this.list = [];
          this.defaultAddress.isDefault = false;
        }
      });
    },
    onLoad () {
      this.listSearch = false;
      this.page++;
      this.loading = true;
      this.nickNameList().then((nickNameList) => {
        this.list = this.list.concat(nickNameList.items);
        this.loading = false;
        if (nickNameList.totalCount <= this.list.length) {
          this.finished = true;
        } else {
          this.onLoad()
        }
      });
    },
    nickNameList () {
      return new Promise((resolve, reject) => {
        service
          .nickNameList(this.content, this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });
    },

    onAdd () {
      this.$router.push({
        name: "buyAgentAdd",
        query: { id: 0, type: "add" }
      });
    },
    // 删除昵称
    onDelete (info) {
      console.log(info, 'info')
      if (this.AgentIsShow == true && info.id == this.agentShow.address.mallAgentId) {
        this.close = true
        this.activeText = '不可删除'
      } else {
        Dialog.confirm({
          message: "确认删除么"
        })
          .then(() => {
            service
              .deleteNickName(info.id)
              .then((res) => {
                if (res.statusCode == 200) {
                  Toast("删除成功");
                  this.init();
                }
              })
              .catch((err) => {
                // Toast(err);
              });
          })
          .catch(() => {
            Toast("你已取消删除");
          });
      }
    }
  },
  mounted () {
    this.init();
    // this.getAddress();
  }
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  // position: fixed;
  // height: calc(100% - 12.7vw);
  min-height: 100vh;
  width: 100%;
  // overflow-y: scroll;
  position: fixed;
  height: calc(100% - 0.7vw);
  background: #f8f8f8;

  // 底部没有更多了
  @{deep}.van-list__finished-text {
    line-height: 16px;
    padding: 8px 0 16px;
  }

  .buyAgentTitle {
    color: #343434;
  }

  .van-search {
    padding: 0;
    border-radius: 20px;
    height: 40px;
    flex: 1;
  }

  .van-search .van-cell {
    @{deep}.van-field__left-icon {
      margin-right: 8px;
      color: #dedcdd;
      font-size: 18px;
    }

    @{deep} .van-icon,
    .van-field__right-icon .van-icon {
      color: #c5c5c5;
    }
  }

  .van-search__content {
    background-color: #fff;
  }

  .van-overlay {
    z-index: 1000;
  }

  .top {
    border-bottom: 1px solid #f7f7f7;
  }

  .nickNameListEmpty {
    .van-cell--center {
      padding: 4.66667vw 4.26667vw;
    }
  }

  .scroll {
    height: calc(100% - 2.3vw);
    overflow-y: auto;
    padding-bottom: 19.4vw;
    padding-top: 73px;
  }

  .scrollAgent {
    height: calc(100% - 2.3vw);
    overflow-y: auto;
    padding-bottom: 32.4vw;
    padding-top: 73px;
  }

  .searchForm {
    margin: 16px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 20px;
    border: 0.5px solid #e6e6e6;
  }

  .searchButton {
    background: #ee0a25;
    border: 0;
    color: #fff;
    border-radius: 18px;
    font-size: 3.2vw;
    height: 28px;
    line-height: 28px;
    padding: 0 12px;
    margin-right: 6px;
    margin-left: 8px;
    text-align: center;
    padding-top: 2px;
  }

  .delete-button {
    height: 100%;
    border-radius: 8px;
  }

  .editNickName {
    .vanNickName {
      padding: 4.26667vw 4.26667vw 0;
      text-align: center;
    }

    .van-cell {
      width: auto;
      padding: 0 4.26667vw;
      height: 40px;
      line-height: 40px;
      margin: 16px 16px 8px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #f2f2f2;
    }

    .redMess {
      padding-left: 32px;
      font-size: 12px;
      margin-bottom: 16px;
      color: #ee0a24;
    }

    .errMessHeight {
      height: 10.66667vw;
      line-height: 10.66667vw;
      margin-bottom: 4.26667vw;
    }
  }
}

.flex_address {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 16px 16px 16px;
  margin: 0 8px 8px 16px;
  border-radius: 8px;
  justify-content: space-between;
  box-shadow: 0px 4px 8px 1px #ebebeb;
  border: 0.5px solid #e6e6e6;
  // height: 44px;
}

.name_list {
  border-radius: 8px;
  border: 1px solid #f7f7f7;
  margin-right: 8px;
  // margin-top: 8px;
}
</style>